<template>
  <div class="header">
    <van-nav-bar :title="headTile" left-arrow>
        <div v-show="backIsshow" @click="goBack" slot="left" >
            <i class="van-icon van-icon-arrow-left van-nav-bar__arrow"></i>
        </div>
        <div v-show="shareIsshow" @click="goShare" slot="right" class="share">
          <span></span>
          <span>分享</span>
        </div>
    </van-nav-bar>
  </div>
</template>

<script>
export default {
    name: "cHeader",
    data() {
        return {
            backIsshow: true,
            shareIsshow: true,
            headTile: ''
        };
    },
    methods:{
        goBack(){
            if (window.history.length <= 1) {
                this.$router.push({path:'/'})
                return false
            } else {
                this.$router.go(-1)
            }
        },
        goShare(){
          //显示分享页面
          Event.$emit('share',true)
        }
    },
    watch: {
        "$route":{
            handler(route,from){
                
                this.headTile = route.meta.title;
                this.backIsshow = route.meta.backIsshow;
                this.shareIsshow = route.meta.shareIsshow;
                if(from.name=="LuckyNumPay"&&localStorage.getItem('orderId')){
                  localStorage.removeItem('orderId')
                }
            }
        }
    },
    created() {
        this.headTile = this.$route.meta.title;
        this.backIsshow = this.$route.meta.backIsshow
        this.shareIsshow = this.$route.meta.shareIsshow
        Event.$on("setTitle", data => {
            this.headTile = data
        })
    }
};
</script>
<style scoped>
  .header{
    width: 100%;
    height: 100px;
    position: fixed;
    top: 0px;
    z-index: 999;
  }
  .van-nav-bar{
    height: 100px;
    line-height: 100px;
    z-index: 1;
    background-color: #FFC016;
    color: #000000;
  }
  .van-nav-bar__title{
    font-size: 32px;
    color: #671D00;
  }
  .van-nav-bar .van-icon {
    font-size: 40px;
    color: #671D00;
    cursor: pointer;
    vertical-align: middle;
  }
  .van-nav-bar__arrow {
    min-width: 1em;
  }
  .van-icon {
    position: relative;
    display: inline-block;
    font: normal normal normal 14px/1 "vant-icon";
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
  }
  .van-icon-arrow-left:before {
    content: "\F008";
  }
  .van-icon::before {
    display: inline-block;
  }
  .share{
    position:relative;
    height: 98px;
    line-height: 98px;
  }
  .share span{
    display:inline-block;
    font-size: 31px;
    color:#671D00;
  }
  .share span:nth-child(1){
    position: absolute;
    margin: auto;
    right:67px;
    top: 0;
    bottom: 0;
    height: 35px;
    width: 39px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAjCAYAAAAXMhMjAAAAAXNSR0IArs4c6QAABPpJREFUWAntWF1oHFUU/u78bjZJt4kJSeu2TWMpQkRBBcEHFfVNfFCKFEVLE12b0iKWIvHnocFfhCAaFUyL4EPVuGDAJ9GXiD4UUSTSUipV+hPTENOk2WSz3Z+Z8buT7ma6OyYTZtInL1zm7p1z5nz3O+eec+8KsHVvwWbVwbNCYLcCtNsAh3Dku4DNoPAlCOwduoCfguikAN1sx8aZAvLHZ5Dx01GeSeJmU0G3wg8TUCeNmHwaFDaDdspTnToCup8RvzktiW0FHX0Ncex5ug31vjJ1ClKOjb18WS8UDDgWfqUhPkASgzXFISyBxWIeJ4NpAJaC7fTNU9RT602IF5M4+t44cl59jcB2U6CNfaCQxTufTmPeK7BeY6FjzC7gA+GgjyBfzZKK1GYcG5rAYtmmencCb/KHoNDg0UmMlV+s9/OXWWTvMfEbNOQYSg8R270kKHvfBvx+IoOStF92nWOLNW2ASLB//A8W6oBBgnvNcWhfoI9+fY4MxqUBjZ3vSJ1TASp/RtJSd0HPjcPY2Ai1VICqWLU2uE0dunhYKaKZsd5Hkl4hKuXAFnwlwUXerq38VjGFB+IGbisU0EoKGhwVMuUQw3JzAZRQ5GyCs4oKtHEfHCoCHZGD29eBDttGL3fwowSyiQYNAmPqhE3XyWd1k56TXbpyKRUJzDoC5yIF17sVnbaFt5jBH6e1eVL0LZ8/0vQ5R0FGVZYC3YuO8iW+b6HcASbLR5jCTjPE+ktxfB8ZuO4WNFoO9hPQLhofo5uOlK7i57kpTKeZ1ryAvGMZAvRlL+XvpDvPCBv9m3bimyOjKEUGTovjDrryCfrtbzLx8tBFfOcF4Tcm002UP0hQh+nyGRaBN2YSGPmEwKR8OZX46Qae29+KBrriMbqmmS79ot6hK1dpPUk0E9g+LuQQWbtCvX7DQDp9CoWyaiTM5TXcpAk8SEOzZGGkugyVjZWfh1lLF1jLydZLnFvkwl6/DHyZPot8WUY+I2GOgd5JYO383l9aHue9BvzGuSbEOH8Le4asvc3dfTxdVVelXmhw8uhDA11cvc7NcFJNLNdGacCvnWrHnKJgkLuzZ2EBn3nrqVc+tFu1LpjWHHYwL8kC+MfkWVz1GvAbjzLgR5ky+E72/2yhmTPnYHCXJWlBMIYmmDaY3KNpocHZOnSCaiUcy9bAuCZ/EbXQ4PJF9/DQIMGxsGcjwuV+JnTM6Tzo5Hk852awLXU5RwUBKVNKzmQtBnLTF3C+upKEZq6ogynOLdqGbq8t3nIx3F5y8LVl492mTkj2r2uhmWOhkccdeXeIqaW1HfGZcet4RNpG3Wnq1hBVM3Ed9AA/Lo9jUhhIxTTsuf8SxgOoVESE5R4IiixdhZxSu5FCM+fGyZ+Ykhbfr5iNZhCauWhg+H/lf3D+vKw+K5ljJmCSijCzr252SYKF360mBOBiqNaruJWCxHdjmyptrlDsJLgZdh7J0OUef24gPrLRRc5M1uZ5xay9Z8jsPkLwT9oOnsdWLKYsjJXpXk+cvI3tpM0XaL/I49aodqb2qKUR/UcUsLiCHl5QBmyF/10s0e0bB6EByziTfzw4qKOBHBPw55aF4WM+Ry0XAK9nLULFLoJ6mEoJnmrXB9i1lREQPYksjfzAKjD84UVM+C26AuLgDphXCKwxjw28MGoM1hVC1e9TweZ4txWiBCumI8P/RzIrXYb+BbKDkG9IaQlUAAAAAElFTkSuQmCC); background-size: 100% 100%;
  }
  .bar__arrow{
      width: 17px;
      height: 33px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/header/header.vue